<template>
  <div class="modal-uploaded-view-wrap">
    <portal to="dash-modal">
      <!-- only for mark as sent -->
      <InvoiceSendAdjustModal
        v-if="showAdjustModal && invoice"
        :invoice-id="invoice.id"
        :mark-as-sent="markedAsSent"
        @mark-invoice-as-sent="$emit('mark-as-sent')"
        @close="closeAdjustModal"
        @marked-as-sent="
          () => {
            $emit('invoice-updated')
            showAdjustModal = false
          }
        "
      />
    </portal>

    <!-- MAIN -->
    <div class="invoice-wrap-bg">
      <div class="invoice-wrap">
        <div class="uploaded-left is-shadow-box">
          <div class="uploaded-details" style="padding: 0 1rem;">
            <div class="uploaded-details--section">
              <!-- Number / name -->
              <div class="uploaded-details--section__item">
                <h4>{{ $gettext('Number') }}</h4>
                <div class="big-item">
                  {{ invoice.number }}
                </div>
              </div>
              <!-- Date / period -->
              <div class="uploaded-details--section__item">
                <h4>{{ $gettext('Invoice date') }}</h4>
                <div class="big-item">
                  {{ invoice.invoice_date | formatDate }}
                </div>
              </div>
              <!-- Customer -->
              <div class="uploaded-details--section__item">
                <h4>{{ $gettext('Customer') }}</h4>
                <div class="big-item">
                  {{ invoice.recipient_customer.name }}
                </div>
              </div>
              <!-- Project -->
              <div v-if="invoice.project" class="uploaded-details--section__item">
                <h4>{{ $gettext('Project') }}</h4>
                <div class="big-item">
                  {{ invoice.project.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="invoice-lines-wrap">
            <InvoiceLinesPreview 
              ref="invoice-lines-preview"
              :invoice="invoice"
              :excludeTableFields="['quantity', 'description']"
            />
          </div>
        </div> <!-- end uploaded-left -->

        <div class="uploaded-right">
          <div v-if="invoice && invoice.pdf_file" class="uploaded-details">
            <div v-if="fileType === 'image'" class="uploaded-img-preview">
              <ImageViewer :zoomable="true" :file-path="invoice.pdf_file" />
            </div>

            <iframe v-if="!forceMobileViewer && !showMobileViewer && fileType === 'pdf' && invoice.pdf_file" id="pdf-frame" class="uploaded-pdf-preview" :src="invoice.pdf_file" />
            <GkPDFViewer v-if="(forceMobileViewer || showMobileViewer) && fileType === 'pdf' && invoice.pdf_file" :item-pdf="invoice.pdf_file" toolbar>
              <template v-slot:title>
                <div>
                  {{ invoice.number }}
                </div>
              </template>
              <template v-slot:actions>
                <GekkoButton
                  :text="$gettext('Download')"
                  @click="downloadInvoice(invoiceId)"
                  :icon="'fa-solid fa-download'"
                  variant="link"
                  size="sm"
                  class="p-0 text-white"
                />
                <GekkoButton
                  v-if="invoice && invoice.status === 'd'"
                  :text="$gettext('Edit design')"
                  @click="$emit('show-design')"
                  :icon="'fa-solid fa-paintbrush'"
                  variant="link"
                  size="sm"
                  class="p-0 text-white"
                />
              </template>
            </GkPDFViewer>
          </div>
        </div>  <!-- end uploaded-left -->

      </div> <!-- end invoice-wrap -->
    </div> <!-- end invoice-wrap-bg -->
  </div> <!-- end modal-uploaded-view-wrap -->
</template>
<script>
import { mapGetters } from "vuex";

import invoices from "@/mixins/invoices";
import pdfviewer from "@/mixins/pdfviewer";

import GekkoButton from "@/components/GekkoButton"
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"
import InvoiceSendAdjustModal from "@/components/invoices/ui/InvoiceSendAdjustModal"
import InvoiceLinesPreview from "@/components/invoices/ui/InvoiceLinesPreview"
import ImageViewer from "@/components/ui/ImageViewer";
import GkPDFViewer from '@/components/invoices/ui/GkPDFViewer'

import InvoiceService from "@/store/services/invoice.service.js"

export default {
  name: "UploadedInvoiceView",
  mixins: [invoices, pdfviewer],
  components: {
    GekkoButton,
    LoadingSpinner,
    InvoiceLinesPreview,
    ImageViewer,
    GkPDFViewer,
    InvoiceSendAdjustModal
  },
  data () {
    return {
      invoiceId: null,
      loading: true,
      loadingPDF: true,
      fileType: '',
      showAdjustModal: false,
      markedAsSent: false
    }
  },
  computed: {
    ...mapGetters({ 
      invoice: "invoices/getInvoice",
    }),
    isEUR () {
      return (this.invoice.currency === 'EUR')
    },
    totalAmountEUR () {
      return this.$options.filters.currency(this.invoice.total_amount, 'EUR', 2)
    },
    totalAmountCurrency () {
      return this.$options.filters.currency(this.invoice.currency_total_amount, this.invoice.currency, 2)
    },
    totalAmount () {
      let total_amount = 0

      if (this.isEUR) {
        total_amount = this.totalAmountEUR
      } else {
        if (this.invoice.total_amount && this.invoice.total_amount > 0) {
          total_amount = this.totalAmountCurrency + ' <span>(' + this.totalAmountEUR + ')</span>'
        } else {
          total_amount = this.totalAmountCurrency
        }
      }

      return total_amount
    }
  },
  created () {
    this.invoiceId = this.$route.params['invoiceId']
    if (this.invoiceId) {
      this.setupData()
    }
  },
  mounted () {
    // loadingPDF triggers pdfviewer.js watcher to evaluate if #pdf-frame can display pdfs
    // hence need to trigger it on mounted
    this.loadingPDF = false
  },
  methods: {
    setupData () {
      if (this.invoice) {
        this.$emit('display-buttons', 'view')

        this.fileType = window.getFileType(this.invoice.pdf_file)
      } else {
        console.log('Invoice is not set')
      }
      this.loading = false
    },
    downloadInvoice(invoice_id) {
      InvoiceService.getInvoicePDFBlob(invoice_id).then(response => {
        this.promptDownload(response)
      }).catch(error => console.error('Error downloading PDF:', error));
    },
    closeAdjustModal() {
      this.showAdjustModal = false
    }
  }
}
</script>
<style scoped lang="scss">
  .modal-uploaded-view-wrap {
    height: 100%;
  }

  .mastermodal-view-wrap {

  }
</style>

<style lang="scss">
  
</style>